var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) { ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVipIconSteamymatches(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 20,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36.122 0H5.878C2.632 0 0 2.62 0 5.853v8.295C0 17.38 2.632 20 5.878 20h30.244C39.368 20 42 17.38 42 14.148V5.853C42 2.62 39.368 0 36.122 0z",
    fill: "var(--sections, #FFFFFF)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M40.62 5.853c0-2.473-2.014-4.479-4.498-4.479H5.878c-2.484 0-4.498 2.006-4.498 4.48v8.294c0 2.474 2.014 4.48 4.498 4.48h30.244c2.484 0 4.499-2.006 4.499-4.48V5.853zm.8 8.295c0 2.914-2.372 5.275-5.298 5.275H5.878c-2.926 0-5.298-2.361-5.298-5.275V5.853C.58 2.94 2.952.578 5.878.578h30.244c2.926 0 5.298 2.362 5.298 5.275v8.295z",
    fill: "var(--featured-primary, #F27405)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.339 4.582h2.756v10.974h-2.756V4.582zm-4.181 0h2.927L13.97 15.507h-2.75L7.105 4.582h2.925l2.562 7.014 2.566-7.014zm12.447 8.23v2.745H24.85V4.582h5.511c1.096 0 2.148.434 2.923 1.205a4.106 4.106 0 010 5.82 4.143 4.143 0 01-2.923 1.206h-2.755zm0-5.486v2.744h2.756c.366 0 .716-.145.974-.402a1.369 1.369 0 00-.974-2.342h-2.756z",
    fill: "var(--featured-primary, #F27405)"
  })));
}
export default SvgVipIconSteamymatches;